import ExternalTransfer from './ExternalTransfer';

export default ExternalTransfer;
